import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["pressed"]

  press() {
    this.element.classList.add(this.pressedClass)
  }

  release() {
    this.element.classList.remove(this.pressedClass)
  }
}
